<template>
  <div class="event-layout">
    <!-- 公共头部 -->
    <Header></Header>
    <!-- 完成进度 -->
    <EvenProgress></EvenProgress>
    <!-- 侧边栏 -->
    <EventAside></EventAside>
    <!-- 公共页面内容结构 -->
    <div class="page-wrapper max-w">
      <!-- 侧边环节栏 -->
      <EventBar></EventBar>
      <!-- 内容部分 -->
      <div class="page-inner">
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import "../../assets/css/student.less"
import Header from "../../components/Header"
import EvenProgress from "../../components/student/EvenProgress"
import EventAside from "../../components/student/EventAside.vue";
import EventBar from "../../components/student/EventBar.vue";

export default {
  name: "eventLayout",
  data () {
    return {
      school_code: localStorage.getItem("schoolCode")
    }
  },
  components: {
    Header,
    EvenProgress,
    EventAside,
    EventBar
  },
  mounted () {
    let { activity_id, course_id } = this.$route.query
    if (!activity_id || !course_id) {
      // this.$message.info("未查询到活动或课程")
      this.$router.push(`/${this.school_code}/student`)
    }
  },
  methods: {

  }
};
</script>

<style lang="less" scoped>
</style>